import React from 'react';
import { useData } from "../../components/context/DataContext";
import { useModalContentUpdate } from "../../components/context/ModalContext"

import './Button.css'

const Button = (props) => {

    const dataState = useData();
    const setModalIndex = useModalContentUpdate()

    const popContent = {
        "idx": dataState.items[props.id].idx,
        "summary": dataState.items[props.id].summary,
        "audio": dataState.items[props.id].audio,
        "transcript": dataState.items[props.id].transcript,
        "speakerimg": dataState.items[props.id].speakerimg
    }

    const handleClick = () => {
        props.clickitem(props.id);
        setModalIndex(popContent);
    }

    return (
        <div className={`btn btn${props.id} ${props.active === 1 ? "active-prog" : ""}` } onClick={handleClick}>
            <div className="icon" style={{backgroundColor: dataState.items[props.id].color }}>
                <div className="icon-img"></div>
            </div>
            <div className="label">
                <p className="label-txt">{dataState.items[props.id].label}</p>
            </div>
        </div>
    );
};

export default Button;